<template>
  <el-dialog
      :title="setId?'修改评分':'创建评分'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600"
      center>
    <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="100px">
      <el-form-item label="评价项" prop="content" v-if="group===2">
        <el-input v-model="scoreForm.content" placeholder="请输入评价项"></el-input>
      </el-form-item>
      <el-form-item label="评价内容" prop="name">
        <el-input v-model="scoreForm.name" placeholder="请输入评价内容"></el-input>
      </el-form-item>
      <el-form-item label="成绩" prop="score">
        <el-select v-model="scoreForm.score" multiple placeholder="请选择" style="width: 100%;">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('scoreForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {scoreValueList} from "@/api/projectOffice";

export default {
  name: "scoreItemDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    group: {
      type: Number
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      options:[],
      scoreForm: {
        content:'',
        name: '',
        score:[],
        scoreValue:[],
        scoreText:[],
      },
      rules: {
        content: [
          {required: true, message: '请输入评价项', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入评价内容', trigger: 'blur'},
        ],
        score: [
          {required: true, message: '请输入成绩', trigger: 'change'},
        ],
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await scoreValueList(
          '',
          1,
          10000);
      this.options = _list.data.list;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', [false,''],)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          let _arr = JSON.parse(JSON.stringify(this.scoreForm.score))
          this.scoreForm.scoreValue=[]
          this.scoreForm.scoreText=[]
          _arr.map(item=>{
            this.options.map(items=>{
              if(item === items.id){
                this.scoreForm.scoreValue.push(items.score)
                this.scoreForm.scoreText.push(items.name)
              }
            })
          })
          this.$emit("cancelDialog", [true,JSON.parse(JSON.stringify(this.scoreForm))]);
          this.$refs[formName].resetFields();
        }
      });
    },
  },
  watch: {
    setItem() {
      this.scoreForm = {
        content: this.setItem.content?this.setItem.content:'',
        name: this.setItem.name?this.setItem.name:'',
        score: this.setItem.score?this.setItem.score:[],
        scoreValue: this.setItem.scoreValue?this.setItem.scoreValue:[],
        scoreText: this.setItem.scoreText?this.setItem.scoreText:[],
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>